import { Alert, Button, Col, Container, Row } from "react-bootstrap";
import { useSurgeryQuery, useSurgerySchedulerSurgeonQuery } from "../../../../queries";
import { usePermissions } from "../../../../contexts";
import { DashboardMetric, UpcomingSurgeries, PendingTissueOffers } from "../..";
import { fas, Icon, LoadingSpinner } from "../../../../component-library";
import { useStoredState } from "../../../../hooks";
import { Link } from "react-router-dom";
import { Claims } from "../../../../models";
import { useState } from "react";
import { CreateSurgeryModal } from "../../..";

export function SurgeryDashboard() {
    const { isSurgeryUser, hasPermission } = usePermissions();
    const {
        surgeryDashboardQuery: { data, isFetching: isFetchingDashboard },
    } = useSurgeryQuery({ queryType: "dashboard" });
    const {
        mySurgeonsQuery: { data: mySurgeons, isFetching: isFetchingSurgeons },
    } = useSurgerySchedulerSurgeonQuery({ queryType: "mySurgeons" });
    const canCreateSurgery = hasPermission(Claims.CreateSurgery);

    const [view, setView] = useStoredState<"offers" | "surgeries">("surgery-dashboard-view", "offers");
    const [showSurgeryModal, setShowSurgeryModal] = useState(false);
    const isFetching = isFetchingDashboard || isFetchingSurgeons;

    if (isFetching) return <LoadingSpinner />;

    return (
        <Container>
            <h1>Surgery Dashboard</h1>

            <Row>
                <Col xxl={3} xl={4} md={6}>
                    <DashboardMetric
                        title="Tissue Offers"
                        value={data?.tissueOffers?.length ?? "-"}
                        onClick={() => setView("offers")}
                        isActive={view === "offers"}
                    />
                </Col>
                <Col xxl={3} xl={4} md={6}>
                    <DashboardMetric
                        title={
                            <span>
                                Upcoming Surgeries{" "}
                                <Icon
                                    icon={fas.faInfoCircle}
                                    title="Surgeries scheduled for the next 7 days"
                                    aria-label="Surgeries scheduled for the next 7 days"
                                    className={view === "surgeries" ? "" : "text-primary"}
                                    inverse={view === "surgeries"}
                                />
                            </span>
                        }
                        value={data?.upcomingSurgeries?.length ?? "-"}
                        onClick={() => setView("surgeries")}
                        isActive={view === "surgeries"}
                    />
                </Col>
                {!isSurgeryUser && (
                    <Col xxl={6} xl={4} md={12} className="d-flex justify-content-end align-items-start">
                        <Link to="/surgery-calendar" className="btn btn-outline-info">
                            View Surgery Calendar
                        </Link>
                        {canCreateSurgery && (
                            <Button variant="primary" onClick={() => setShowSurgeryModal(true)} className="ms-2">
                                <Icon icon={fas.faPlus} className="me-1" /> New Surgery
                            </Button>
                        )}
                    </Col>
                )}
            </Row>

            {isSurgeryUser && !isFetching && !mySurgeons?.length && (
                <Alert variant="danger" className="mt-1">
                    You are not assigned to any surgeons. Please contact your administrator to be added to a surgeon.
                </Alert>
            )}

            {view === "offers" && <PendingTissueOffers tissueOffers={data?.tissueOffers ?? []} />}
            {view === "surgeries" && <UpcomingSurgeries surgeries={data?.upcomingSurgeries ?? []} />}
            {showSurgeryModal && (
                <CreateSurgeryModal onHide={() => setShowSurgeryModal(false)} show={showSurgeryModal} />
            )}
        </Container>
    );
}
